<h2>Teilnehmer</h2>
@if ((!tteId) && generalConfig) {
  <div class="grid">
    <div class="col-12 attendeeSummary">
      <span class="attendeeCount">Angemeldete Interessierte: {{generalConfig.attendeeCount}}</span>
      <p-button pTooltip="Teilnehmerliste exportieren" icon="pi pi-download" (click)="download()" ariaLabel="Teilnehmerliste exportieren"></p-button>
      <p-button pTooltip="Teilnehmerliste löschen" icon="pi pi-times-circle" (click)="deleteAllUsers()" ariaLabel="Teilnehmerliste löschen"></p-button>
    </div>
  </div>
}
<p-table [value]="attendees">
  @if (tteId) {
    <ng-template pTemplate="caption">
      <div class="caption">
        <div>
          Teilnehmende der Veranstaltung @if (timetableEntry?.subtitle) {
          <span style="font-style: italic">{{timetableEntry?.subtitle}}</span>
          } {{timetableEntry?.title}}, bei {{timetableEntry?.host}}
        </div>
        <p-button label="Teilnehmer hinzufügen" icon="pi pi-plus" (click)="showDialog = true" ariaLabel="Teilnehmer hinzufügen"></p-button>
      </div>
    </ng-template>
  }
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>E-Mail</th>
      <th class="actionColumn"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-attendee>
    <tr>
      <td>{{attendee.firstname}} {{attendee.lastname}}</td>
      <td>{{attendee.email}}</td>
      <td class="actionColumn">
        <p-button icon="pi pi-info" pTooltip="Mehr Informationen anzeigen" (click)="changeAttendee(attendee)" ariaLabel="Mehr Informationen anzeigen"></p-button>
        <p-button icon="pi pi-trash" pTooltip="{{timetableEntry?'Anmeldung für diese Veranstaltung löschen':'Teilnehmer entfernen'}}" (click)="removeAttendee(attendee)" ariaLabel="Entfernen"></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4">Bisher keine Anmeldungen.</td>
    </tr>
  </ng-template>
  @if (tteId) {
    <ng-template pTemplate="summary">
      <div class="flex gap-2 justify-content-end align-items-center p-3">
        <p-button label="Zurück" (click)="back()" ariaLabel="Zurück"></p-button>
        <p-button label="Teilnehmerliste exportieren" icon="pi pi-download" (click)="download()" ariaLabel="Teilnehmerliste exportieren"></p-button>
      </div>
    </ng-template>
  }
</p-table>

@if (timetableEntry&&allAttendees) {
  <p-dialog [(visible)]="showDialog" [style]="{width: '50vw', height: '75vh'}" [resizable]="false" (onHide)="hideAddAttendee()" [modal]="true">
    <input pInputText type="text" [(ngModel)]="attendeeSearch" (ngModelChange)="filterAttendees()" placeholder="Teilnehmer suchen" autofocus class="mb-2">
    <p-table [value]="filteredAttendees">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>E-Mail</th>
          <th width="4.5rem" class="actionColumn"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-attendee>
        <tr>
          <td>{{attendee.firstname}} {{attendee.lastname}}</td>
          <td>{{attendee.email}}</td>
          <td class="actionColumn">
            <p-button icon="pi pi-plus" pTooltip="Teilnehmer hinzufügen" (click)="addAttendee(attendee)" ariaLabel="Teilnehmer hinzufügen"></p-button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-dialog>
}
